import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { Row, Col, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import AsideComponent from "../includes/asideComponent/AsideComponent";
import { Prompt } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import SidebarJs from "../../common/js/sidebarAnimation";
import './capabilityMapping.css';
import ApiServer from "./../../common/js/ApiServices.js";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import { Link } from 'react-router-dom';
import { responseMessage } from '../../utils/alert';
import { startLoader, stopLoader } from '../../actions/loaderActions';

import axios from 'axios';
const config = require('../../config');


class CapabilityMapping extends React.Component {
  constructor(props) {
    super(props);
    this.sidebarAnimation = new SidebarJs();
    this.apiServer = new ApiServer(true);
    this.capabilityModellingProjectData = [];
    this.benchmarkProjectData = [];
    this.userDomainsData = [];
    this.capabilityData = [];
    this.mappingMatrixData = [];

    this.state = {
      finalizeMapping: false,
      versionClicked: false,
      updateVersion: false,
      hasInprogressData: false,
      selectedDecompositionProjectID: 0,
      selectedDecompositionProjectName: '',
      selectedCapabilityMappingName: '',
      selectedBenchmarkProjectID: 0,
      selectedBenchmarkProjectName: '',
      selectedCapabilityModellingProject: [],
      capabilityModellingProjectData: [],
      benchmarkProjectData: [],
      userDomainsData: [],
      capabilityData: [],
      allCapabilityIdArr: [],
      checkedCapabilityIdArr: [],
      tempCapabilityMappingID: 0,
      CapabilityMappingID: 0,
      latestVersionID: 0,
      templatestVersionID: 0,
      matrixDisplayLabel: '',
      mappingMatrixData: [],
      mappingModificationStarted: false,
      selectButtonDisableStatus: true,
      versionData: [],
      saveProgressButtonText: "Save Progress",
      validationError: {
        assesmentName: false
      },

      // NEW: domain averages state (DomainID -> avg score)
      domainAverages: {}
    };

    this.validator = new SimpleReactValidator({
      element: message => {
        return <p className="text-danger">{message}</p>;
      },
      autoForceUpdate: this
    });
  }

  // NEW: recompute averages whenever mapping/capabilities/domains change
  recomputeDomainAverages = () => {
    const { mappingMatrixData, capabilityData, userDomainsData } = this.state;

    // map capabilityId -> numeric score (try multiple possible field names just in case)
    const scoreByCapId = new Map(
      capabilityData.map(c => {
        const raw =
          c.CapabilityScore !== undefined && c.CapabilityScore !== null ? c.CapabilityScore :
            c.AggrScore !== undefined && c.AggrScore !== null ? c.AggrScore :
              c.Score !== undefined && c.Score !== null ? c.Score : null;
        const num = raw === null ? null : Number(raw);
        return [String(c.DecompositionProcessLevel1ID), isNaN(num) ? null : num];
      })
    );

    // collect scores per domain, but only for mapped pairs
    const buckets = {}; // DomainID -> number[]
    mappingMatrixData.forEach(pair => {
      const [capId, domId] = String(pair).split('|');
      const s = scoreByCapId.get(String(capId));
      if (s === null || s === undefined) return; // skip missing
      if (!buckets[domId]) buckets[domId] = [];
      buckets[domId].push(s);
    });

    // average per domain
    const avgs = {};
    userDomainsData.forEach(d => {
      const arr = buckets[String(d.DomainID)] || [];
      avgs[d.DomainID] = arr.length ? +(arr.reduce((a, b) => a + b, 0) / arr.length).toFixed(2) : null;
    });

    this.setState({ domainAverages: avgs });
  };

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.beforeunload.bind(this));
  }

  beforeunload(e) {
    if (this.state.mappingModificationStarted) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  componentDidMount() {
    this.props.startLoader();
    this.sidebarAnimation.toggle();
    this.fetchCapabilityModellingProjectData();
  }


  showValidationMessage(event) {
    if (this.validator.fieldValid(event.target.name)) {
      this.validator.hideMessageFor(event.target.name);
      this.setState({
        validationError: {
          ...this.state.validationError,
          [event.target.name]: false
        }
      });
    } else {
      this.validator.showMessageFor(event.target.name);
      this.setState({
        validationError: {
          ...this.state.validationError,
          [event.target.name]: true
        }
      });
    }
  }

  fetchDefaultMappingMatrixData() {
    // CapabilityMappingID
    let capabilityMappingID = 0;

    this.setState({
      mappingMatrixData: []
    });

    if (this.state.versionClicked) {
      capabilityMappingID = this.state.CapabilityMappingID;
    }

    return this.apiServer
      .SendRequest({
        method: "GET",
        url: "/capability-mapping/" + capabilityMappingID + "/" + this.state.selectedBenchmarkProjectID + "/" + this.state.selectedDecompositionProjectID,
        data: ""
      })
      .then(result => {
        if (result.success === true) {
          if (result.data.mapping) {
            if (result.data[0].Version == 0) {
              this.setState({
                CapabilityMappingID: result.data[0].CapabilityMappingID,
                hasInprogressData: true,
              });
            }

            let matrix = this.state.mappingMatrixData;
            let checkedCapabilityIdArr = [];

            result.data.mapping.forEach(elem => {
              matrix.push(elem.DecompositionProcessLevel1ID + '|' + elem.DomainID);
              checkedCapabilityIdArr.push(elem.DecompositionProcessLevel1ID);
            });

            let uniqueArray = checkedCapabilityIdArr.filter(function (item, pos) {
              return checkedCapabilityIdArr.indexOf(item) == pos;
            });

            let tempVDisp = '';
            if (result.data[0].Version == 0) {
              if (parseInt(result.data[0].basedOnVersionID) > 0) {
                tempVDisp = ' based on version';
              }
            }

            this.setState({
              mappingMatrixData: [...matrix],
              checkedCapabilityIdArr: uniqueArray,
              latestVersionID: (result.data[0].Version == 0) ? parseInt(result.data[0].basedOnVersionID) : result.data[0].Version,
              matrixDisplayLabel: (result.data[0].Version == 0) ? 'Change in progress' : ''
            }, this.recomputeDomainAverages); // NEW: recompute
          }
        }
      })
      .catch(error => {
        responseMessage("error", "Sorry something went wrong. Please try again", "");
        console.log(error);
      });
  }


  fetchVersionListingData() {
    return this.apiServer
      .SendRequest({
        method: "GET",
        url: "/capability-mapping-list/" + this.state.selectedBenchmarkProjectID + "/" + this.state.selectedDecompositionProjectID,
        data: ""
      })
      .then(result => {
        if (result.success === true) {
          if (result.data.length > 0) {
            let versionData = [...result.data];
            let latestVersionID = 0;
            if (versionData.length > 0) {
              versionData.forEach(elem => {
                latestVersionID = elem.Version;
              });
            }
            this.setState({
              versionData: [...versionData]
            });
          }
        }
      })
      .catch(error => {
        responseMessage("error", "Sorry something went wrong. Please try again", "");
        console.log(error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedBenchmarkProjectID !== this.state.selectedBenchmarkProjectID && this.state.selectedBenchmarkProjectID > 0) {
      this.fetchVersionListingData();
      this.fetchDefaultMappingMatrixData();
    }

  }


  handleVersionChange = (e, val) => {
    this.setState({
      tempCapabilityMappingID: val.CapabilityMappingID,
      templatestVersionID: parseInt(val.Version),
      selectButtonDisableStatus: false
    });
  }

  selectVersion = (e) => {
    let versionMsg = 'Do you want to change capability mapping version?';

    if (this.state.hasInprogressData) {
      versionMsg = 'Changes will be lost. Do you want to change capability mapping version?';

    } else if (this.state.mappingModificationStarted) {
      versionMsg = 'Changes made since last save will be lost. Do you want to change capability mapping version?';
    }
    e.preventDefault();
    confirmAlert({
      title: 'Confirmation',
      message: versionMsg,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {

            this.props.startLoader();
            this.mappingMatrixData = [];
            let tempCapabilityMappingID = this.state.tempCapabilityMappingID;
            let templatestVersionID = this.state.templatestVersionID;
            this.setState({
              finalizeMapping: false,
              mappingModificationStarted: false,
              matrixDisplayLabel: '',
              latestVersionID: templatestVersionID,
              templatestVersionID: 0,
              saveProgressButtonText: "Save Progress",
              versionClicked: true,
              updateVersion: false,
              mappingMatrixData: [],
              CapabilityMappingID: tempCapabilityMappingID,
              tempCapabilityMappingID: 0
            }, () => {
              this.fetchDefaultMappingMatrixData();
              let selfObj = this;
              setTimeout(function () {
                selfObj.props.stopLoader();
              }, 1000);
            });
          }
        },
        {
          label: 'No',
          onClick: () => {
            if (this.state.templatestVersionID > 0) {
              document.getElementById('capability_mapping_radio_' + this.state.templatestVersionID).checked = false;
            }

            if (this.state.latestVersionID > 0 && this.state.versionClicked) {
              document.getElementById('capability_mapping_radio_' + this.state.latestVersionID).checked = true;
            }
          }
        }
      ]
    });

  }

  fetchCapabilityModellingProjectData() {
    let headers = {};
    const projectSelection = sessionStorage.getItem("projectSelection");
    let preSelectDecompID = 0;

    if (projectSelection) {
      try {
        const projSel = JSON.parse(projectSelection);
        if (projSel.capProject?.DecompositionProjectID) {
          preSelectDecompID = projSel.capProject.DecompositionProjectID;
        }
        if (String(sessionStorage.getItem("UserType")) === "1" && sessionStorage.getItem("Email")?.toLowerCase() === "superadmin@amplo.com") {
          if (projSel.client?.user_id || projSel.client?.UserID) {
            headers['x-user-id'] = projSel.client.user_id || projSel.client.UserID;
          }
          if (projSel.client?.company_id || projSel.client?.CompanyID) {
            headers['x-company-id'] = projSel.client.company_id || projSel.client.CompanyID;
          }
        }
      } catch (e) {
        console.error("Error parsing projectSelection", e);
      }
    }

    return this.apiServer
      .SendRequest({
        method: "GET",
        url: "/capability-mapping-modeling-project",
        data: "",
        headers: headers // Use custom headers
      })
      .then(result => {
        if (result.success === true) {
          if (result.data.length > 0) {
            this.capabilityModellingProjectData = [...result.data];

            // Check if we should pre-select
            let shouldSelect = false;
            if (preSelectDecompID > 0) {
              // Verify if it exists in the list
              const exists = this.capabilityModellingProjectData.find(p => String(p.DecompositionProjectID) === String(preSelectDecompID));
              if (exists) shouldSelect = true;
            }

            this.setState({
              capabilityModellingProjectData: [...this.capabilityModellingProjectData],
              selectedDecompositionProjectID: shouldSelect ? preSelectDecompID : (this.state.selectedDecompositionProjectID || 0)
            }, () => {
              if (shouldSelect) {
                this.LinkedBenchmarkingProject();
              }
            });
          }

        }
        this.props.stopLoader();
      })
      .catch(error => {
        this.props.stopLoader();
        responseMessage("error", "Sorry something went wrong. Please try again", "");
        console.log(error);
      });
  }

  getDomainNames(benchmarkProjectID) {
    return this.apiServer
      .SendRequest({
        method: "GET",
        url: "/get_user_domains_bm_project/" + benchmarkProjectID,
        data: ""
      })
      .then(result => {
        if (result.success === true) {
          if (result.data.length > 0) {
            this.userDomainsData = [...result.data];
            this.setState({
              userDomainsData: [...this.userDomainsData]
            }, this.recomputeDomainAverages); // NEW: recompute when domains arrive
          } else {
            this.setState({
              selectedCapabilityMappingName: '',
              userDomainsData: [],
              domainAverages: {} // NEW: clear
            });
            responseMessage("error", "No domain found", "");
          }
        }
      })
      .catch(error => {
        responseMessage("error", "Sorry something went wrong. Please try again", "");
        console.log(error);
      });
  }

  getCapabilityNames() {
    return this.apiServer
      .SendRequest({
        method: "GET",
        url: "/capability-mapping-modeling-project-capability/" + this.state.selectedDecompositionProjectID,
        data: ""
      })
      .then(result => {
        if (result.success === true) {
          if (result.data.length > 0) {
            this.capabilityData = [...result.data];
            let localCapabilityArr = [];

            this.capabilityData.forEach(elem => {
              localCapabilityArr.push(elem.DecompositionProcessLevel1ID);
            });

            this.setState({
              capabilityData: [...this.capabilityData],
              allCapabilityIdArr: localCapabilityArr
            }, this.recomputeDomainAverages); // NEW: recompute when capabilities arrive
          } else {
            this.setState({
              selectedCapabilityMappingName: '',
              capabilityData: [],
              allCapabilityIdArr: [],
            }, this.recomputeDomainAverages); // NEW: clear
            responseMessage("error", "No capability found", "");
          }
        }
      })
      .catch(error => {
        responseMessage("error", "Sorry something went wrong. Please try again", "");
        console.log(error);
      });
  }

  LinkedBenchmarkingProject() {
    this.props.startLoader();
    return this.apiServer
      .SendRequest({
        method: "GET",
        url: "/capability-mapping-linked-benchmark-project/" + this.state.selectedDecompositionProjectID,
        data: ""
      })
      .then(result => {
        if (result.success === true) {
          if (result.data.length == 0) {
            responseMessage("error", "Project not linked with Benchmarking project", "");
            this.props.stopLoader();
          } else {
            let selectedDecompositionProjectName = '';
            this.state.capabilityModellingProjectData.forEach(elem => {
              if (elem.DecompositionProjectID == this.state.selectedDecompositionProjectID) {
                selectedDecompositionProjectName = elem.ProjectName;
              }
            });

            this.setState({ selectedBenchmarkProjectID: result.data.BenchmarkProjectID, selectedBenchmarkProjectName: result.data.BenchmarkProjectName, selectedDecompositionProjectName: selectedDecompositionProjectName, selectedCapabilityMappingName: result.data.BenchmarkProjectName + '-' + selectedDecompositionProjectName, mappingModificationStarted: false });
            this.getDomainNames(result.data.BenchmarkProjectID);
            this.getCapabilityNames();
            let selfObj = this;
            setTimeout(function () {
              selfObj.props.stopLoader();
            }, 7000);
          }

        }
      })
      .catch(error => {
        responseMessage("error", "Sorry something went wrong. Please try again", "");
        console.log(error);
      });
  }

  finalizeMapping(event) {
    if (event.target.checked) {
      if (this.state.checkedCapabilityIdArr.length < this.state.allCapabilityIdArr.length) {
        responseMessage("error", "Each capability needs to be mapped with at least one domain", "");
        return false;
      }
      this.setState({ finalizeMapping: true, saveProgressButtonText: "Create new version" });

    } else {
      this.setState({ finalizeMapping: false, saveProgressButtonText: "Save Progress" });
    }
  }

  computeReestablishFromState = () => {
    const mappingMatrixData = this.state.mappingMatrixData || [];
    const capabilityData = this.state.capabilityData || [];

    // capabilityId -> numeric score
    const capScore = {};
    for (let i = 0; i < capabilityData.length; i++) {
      const c = capabilityData[i];
      const id = String(c.DecompositionProcessLevel1ID);
      // no '??' here; treat 0 as valid
      const raw = (c.CapabilityScore != null)
        ? c.CapabilityScore
        : (c.AggrScore != null)
          ? c.AggrScore
          : (c.Score != null)
            ? c.Score
            : null;
      const num = raw == null ? NaN : Number(raw);
      capScore[id] = isFinite(num) ? num : null;
    }

    // DomainID -> [scores...]
    const buckets = {};
    for (let i = 0; i < mappingMatrixData.length; i++) {
      const parts = String(mappingMatrixData[i]).split('|');
      const capId = String(parts[0]);
      const domId = String(parts[1]);
      const s = capScore[capId];
      if (s != null) {
        if (!Object.prototype.hasOwnProperty.call(buckets, domId)) {
          buckets[domId] = [];
        }
        buckets[domId].push(s);
      }
    }

    const domainIds = Object.keys(buckets);
    if (!domainIds.length) return 0;

    const domainAvgs = [];
    for (let i = 0; i < domainIds.length; i++) {
      const arr = buckets[domainIds[i]];
      if (!arr.length) continue;
      const sum = arr.reduce((a, b) => a + b, 0);
      domainAvgs.push(sum / arr.length);
    }

    if (!domainAvgs.length) return 0;
    const overall = domainAvgs.reduce((a, b) => a + b, 0) / domainAvgs.length;
    return Number(overall.toFixed(2));
  };



  async saveProgress(e) {
    e.preventDefault();
    this.props.startLoader();
    let mappingMatrixString = this.state.mappingMatrixData.toString();
    let domainScores = this.state.userDomainsData.map(d => ({
      domainId: d.DomainID,
      domainName: d.DomainName,
      avgScore: this.state.domainAverages[d.DomainID]
    }));
    let data = {
      "BenchmarkProjectID": parseInt(this.state.selectedBenchmarkProjectID),
      "DecompositionProjectID": parseInt(this.state.selectedDecompositionProjectID),
      "CapabiltyMappingName": this.state.selectedCapabilityMappingName,
      "finalizeMapping": this.state.finalizeMapping,
      "basedOnVersionID": this.state.latestVersionID,
      "CapabilityMappingID": this.state.CapabilityMappingID,
      'mapping': mappingMatrixString,
      "update": this.state.updateVersion,
      "ReestablishAsIsAflyScore": this.computeReestablishFromState(),
      "DomainAverages": domainScores
    }
    let selfObj = this;
    await axios.post(config.laravelBaseUrl + 'capability-mapping-save', data, {
      headers: {
        "authorization": "Bearer " + sessionStorage.getItem("userToken")
      }
    }).then(function (response) {
      selfObj.props.stopLoader();
      responseMessage("success", response.data.message, "");

      selfObj.setState({
        CapabilityMappingID: 0,
        matrixDisplayLabel: '',
        saveProgressButtonText: "Save Progress",
        finalizeMapping: false,
        hasInprogressData: false,
        mappingModificationStarted: false
      }, () => { selfObj.fetchVersionListingData(); selfObj.fetchDefaultMappingMatrixData() });

      if (selfObj.state.versionData.length > 0) {
        document.querySelector('input[name="selectedVersion"]:checked').checked = false;
      }

    }).catch(function (error) {
      selfObj.props.stopLoader();
      console.log(error);
    });
  }

  resetAfterSave() {
    this.setState({ CapabilityMappingID: 0, saveProgressButtonText: "Save Progress", hasInprogressData: false, finalizeMapping: false, mappingModificationStarted: false });
    document.querySelector('input[name="selectedVersion"]:checked').checked = false;
  }

  saveMappingProgress(mappingId) {
    this.mappingMatrixData = this.state.mappingMatrixData;
    const arr = this.mappingMatrixData;
    const newId = mappingId;

    if (!arr.includes(newId)) {
      arr.push(newId);
    } else {
      arr.splice(arr.indexOf(newId), 1);
    }
    this.mappingMatrixData = arr;

    // checkedCapabilityIdArr
    let checkedCapabilityIdArr = [];
    this.mappingMatrixData.forEach(elem => {
      const matrixArray = elem.split("|");
      checkedCapabilityIdArr.push(matrixArray[0]);
    });

    let uniqueArray = checkedCapabilityIdArr.filter(function (item, pos) {
      return checkedCapabilityIdArr.indexOf(item) == pos;
    });

    this.setState({
      mappingMatrixData: [...this.mappingMatrixData],
      checkedCapabilityIdArr: uniqueArray,
      mappingModificationStarted: true
    }, this.recomputeDomainAverages); // NEW: recompute on every toggle
  }

  cancelProgress(e) {
    e.preventDefault();
    let versionMsg = 'Changes made since last save will be lost. Do you want to cancel modification?';

    confirmAlert({
      title: 'Confirmation',
      message: versionMsg,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.startLoader();
            this.mappingMatrixData = [];
            this.setState({
              mappingModificationStarted: false,
              finalizeMapping: false,
              saveProgressButtonText: "Save Progress"
            }, () => {
              this.fetchDefaultMappingMatrixData();
              let selfObj = this;
              setTimeout(function () {
                selfObj.props.stopLoader();
              }, 1000);
            });

          }
        },
        {
          label: 'No',
          onClick: () => { /* noop */ }
        }
      ]
    });
  }

  scoreEmoji = (v) => {
    if (v === null || v === undefined) return "🤔";
    if (v >= 4) return "😃";
    if (v >= 3) return "🙂";
    if (v >= 2) return "😐";
    if (v >= 1) return "😕";
    return "😟";
  };

  scoreColor = (v) => {
    if (v === null || v === undefined) return "#e5e7eb"; // gray-200
    if (v >= 4) return "#22c55e"; // green-500
    if (v >= 3) return "#84cc16"; // lime-500
    if (v >= 2) return "#f59e0b"; // amber-500
    if (v >= 1) return "#f97316"; // orange-500
    return "#ef4444";             // red-500
  };

  fmtScore = (v) => (v === null || v === undefined ? "—" : Number(v).toFixed(2));

  render() {
    const fmt = (v) => (v === null || v === undefined ? '—' : Number(v).toFixed(2));

    return [
      <DashboardHeader key="hdr"></DashboardHeader>,
      <div id="wrapper" key="wrap">
        <Prompt
          when={this.state.mappingModificationStarted}
          message={() =>
            `Unsaved changes. Changes made since last save will be lost. Do you want to continue?`
          }
        />
        <DashboardSidebar></DashboardSidebar>
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <ol className="breadcrumb dashbread">
              <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
              <li className="breadcrumb-item active">Capability Mapping</li>
              <li className="breadcrumb-menu d-md-down-none ml-auto">
                {<img src={require('./../../common/images/diva-icon.png')} className="logo-img" alt="Logo" />}
                <a className="btn powered p-0" href="#">
                  <i className="icon-graph"></i> &nbsp;
                  <i>Powered by Amploglobal</i>
                </a>
              </li>
            </ol>

            <div className="capabilityMappingWrapper mt-4">
              <div className="capability-mapping-section">
                <div className="inner-section">
                  <Row className="business-decomposition-sec">
                    <Col xl="12" className="pr-0">
                      <div className="model-list">
                        <Label className="model-label">Select Capability Modeling Project</Label>
                      </div>
                    </Col>
                    <Col xl="12" className="pr-0">
                      <div className="model-list">
                        <select className="form-control inner-width" value={this.state.selectedDecompositionProjectID} onChange={(e) => this.setState({
                          latestVersionID: 0,
                          matrixDisplayLabel: '',
                          selectedDecompositionProjectID: e.target.value,
                          selectedDecompositionProjectName: '',
                          selectedCapabilityMappingName: '',
                          selectedBenchmarkProjectID: '',
                          selectedBenchmarkProjectName: '',
                          benchmarkProjectData: [],
                          userDomainsData: [],
                          capabilityData: [],
                          versionData: [],
                          tempCapabilityMappingID: 0,
                          CapabilityMappingID: 0,
                          hasInprogressData: false,
                          versionClicked: false,
                          updateVersion: false,
                          selectButtonDisableStatus: true,
                          domainAverages: {} // NEW: clear on project change
                        }, () => { this.LinkedBenchmarkingProject(); })}>
                          <option value="">Select Project</option>
                          {this.state.capabilityModellingProjectData.map(rel => {
                            return <option key={`rel_${rel.DecompositionProjectID}`} value={rel.DecompositionProjectID}>{rel.ProjectName}</option>
                          })}
                        </select>

                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="inner-section">
                  <Row className="business-decomposition-sec">
                    <Col xl="12" className="pr-0">
                      <div className="model-list">
                        <Label className="model-label">Linked Benchmarking Project</Label>
                      </div>
                    </Col>
                    <Col xl="12" className="pr-0">
                      <div className="model-list">
                        <input
                          type="text"
                          readOnly
                          name=""
                          placeholder=""
                          className="form-control inner-width"
                          value={this.state.selectedBenchmarkProjectName}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="inner-section">
                  <Row className="business-decomposition-sec">
                    <Col xl="12" className="pr-0">
                      <div className="model-list">
                        <Label className="model-label">Capability Mapping</Label>
                      </div>
                    </Col>
                    <Col xl="12" className="pr-0">
                      <div className="model-list">
                        <input
                          type="text"
                          readOnly
                          name=""
                          placeholder=""
                          className="form-control inner-width"
                          value={this.state.selectedCapabilityMappingName}
                        />

                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              {
                this.state.userDomainsData.length > 0 &&

                <div className="domain-name-section">
                  <div className="domain-mapping-panel">
                    {(this.state.latestVersionID > 0 || this.state.matrixDisplayLabel != '') ?
                      <div className="capability-mapping-section">
                        <div className="col-sm-12 pl-0">
                          <span className="badge badge-info badge-counter beta-b" style={{ padding: "8px", fontSize: "13px" }}>
                            {this.state.matrixDisplayLabel != '' ? this.state.matrixDisplayLabel + ' ' : ''}
                            {this.state.latestVersionID > 0 ? ' version - ' + this.state.latestVersionID + '.0' : ' '}
                          </span>
                        </div>
                      </div>
                      : null}
                    <div className="domain-mapping-section">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ width: "25%", left: "0", zIndex: "999" }}></th>
                            {this.state.userDomainsData.map(rel => {
                              return (
                                <th key={`hdr_${rel.DomainID}`}>{rel.DomainName}</th>
                              )
                            })}
                          </tr>
                        </thead>
                        <tbody>

                          {this.state.capabilityData.map((relCapability, ind) => {
                            return (
                              <tr key={`capability_mapping_${ind}`}>
                                <td className="stickycol"><strong>{relCapability.ProcessLevel1Title}</strong></td>
                                {this.state.userDomainsData.map(relDomain => {
                                  return (
                                    <td className="text-center" key={`cell_${relCapability.DecompositionProcessLevel1ID}_${relDomain.DomainID}`}>
                                      <input type="checkbox"
                                        name="capability_mapping"
                                        checked={(this.state.mappingMatrixData.includes(relCapability.DecompositionProcessLevel1ID + '|' + relDomain.DomainID)) ? true : false}
                                        value={relCapability.DecompositionProcessLevel1ID + '-' + relDomain.DomainID}
                                        title={` ${relCapability.ProcessLevel1Title} > ${relDomain.DomainName}`}
                                        onChange={() => this.saveMappingProgress(relCapability.DecompositionProcessLevel1ID + '|' + relDomain.DomainID)}
                                      />
                                    </td>
                                  )
                                })}
                              </tr>
                            )
                          })}

                          {/* NEW: domain averages row */}
                          <tr key="domain_averages" style={{ background: '#f8fafc' }}>
                            <td className="stickycol"><strong>Domain Capability Average</strong></td>
                            {this.state.userDomainsData.map(d => {
                              const v = this.state.domainAverages?.[d.DomainID];
                              return (
                                <td key={`avg_${d.DomainID}`} className="text-center">
                                  <strong>{fmt(v)}</strong>
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex save-progress-panel">
                      <div style={{ width: "33%" }}></div>
                      <div style={{ width: "33%" }}>
                        <input type="checkbox"
                          title={`Finalize Mapping`}
                          onClick={this.finalizeMapping.bind(this)}
                          checked={this.state.finalizeMapping}
                        />{" "}Finalize Mapping</div>
                      <div style={{ width: "33%", display: "flex", justifyContent: "flex-end", marginRight: "15px", marginTop: "10px" }}>
                        <button style={{ marginRight: "10px", padding: 7, fontSize: "12px" }} disabled={this.state.mappingModificationStarted ? false : true} onClick={(e) => this.cancelProgress(e)} type="button" className="btn btn btn-danger">Cancel</button>
                        <button style={{ padding: 7, fontSize: "12px" }} disabled={(this.state.mappingModificationStarted || this.state.finalizeMapping) ? false : true} onClick={(e) => this.saveProgress(e)} type="button" className="btn btn btn-primary">{this.state.saveProgressButtonText}</button>
                      </div>
                    </div>
                  </div>
                  <div className="domain-mapping-version-section">
                    <div
                      style={{
                        border: "2px solid #e5e7eb",
                        borderRadius: 16,
                        background: "#fff",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                        padding: "16px 18px"
                      }}
                    >
                      {/* centered title */}
                      <div
                        style={{
                          textAlign: "center",
                          fontWeight: 800,
                          fontSize: 16,
                          letterSpacing: 0.3,
                          color: "#111827",
                          marginBottom: 12
                        }}
                      >
                        Re-benchmarking score
                      </div>

                      {this.state.userDomainsData.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                          {this.state.userDomainsData.map((d) => {
                            const v = this.state.domainAverages?.[d.DomainID];
                            const barPct = v ? Math.max(0, Math.min(100, (v / 5) * 100)) : 0; // 0–5 scale

                            return (
                              <div
                                key={`avg_card_${d.DomainID}`}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 12,
                                  padding: 12,
                                  borderRadius: 12,
                                  background: "#f9fafb",
                                  border: "1px solid #e5e7eb",
                                  borderLeft: `4px solid ${this.scoreColor(v)}`
                                }}
                                title={`${d.DomainName} • Avg ${this.fmtScore(v)}`}
                              >
                                {/* emoji badge */}
                                <div
                                  style={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: "50%",
                                    background: this.scoreColor(v),
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 22,
                                    flex: "0 0 auto",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.12)"
                                  }}
                                >
                                  {this.scoreEmoji(v)}
                                </div>

                                {/* text + progress */}
                                <div style={{ flex: 1 }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "baseline"
                                    }}
                                  >
                                    <div style={{ fontWeight: 700, color: "#111827" }}>
                                      {d.DomainName}
                                    </div>
                                    <div style={{ fontSize: 12, color: "#6b7280" }}>
                                      Avg:{" "}
                                      <strong style={{ color: this.scoreColor(v) }}>
                                        {this.fmtScore(v)}
                                      </strong>
                                    </div>
                                  </div>

                                  {/* progress bar */}
                                  <div
                                    style={{
                                      marginTop: 8,
                                      height: 10,
                                      background: "#e5e7eb",
                                      borderRadius: 9999,
                                      overflow: "hidden"
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "100%",
                                        width: `${barPct}%`,
                                        background: this.scoreColor(v),
                                        transition: "width .4s ease"
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="text-muted" style={{ textAlign: "center", padding: "12px 0" }}>
                          No domains found.
                        </div>
                      )}
                    </div>
                  </div>


                </div>
              }
            </div>


          </div>
        </div>
      </div>,
      <AsideComponent key="aside"></AsideComponent>,
      <FooterComponent key="ftr"></FooterComponent>
    ];
  }
}

export default connect(null, { startLoader, stopLoader })(CapabilityMapping);
